<div appTheme>
    <div class="main-container scrolling fixed-width-container">
        <div class="container col-sm-12">
            <h1>Support</h1>
            <hr>
            <div class="row">
                <div class="col-sm-8">
                    <div class="support-section">
                        <span class="name">Resources</span>
                        <p><a href="{{baseURLForUserGuide}}/en_us/user_documents/SMRTScape_Support.pdf"
                                target="_blank">User Guide</a></p>
                    </div>

                    <div class="support-section">
                        <span class="name">Our Location</span>
                        <p-gmap [options]="options" [overlays]="overlays"
                            [styleClass]="'footer-support-google-map'"></p-gmap>
                    </div>
                </div>

                <div class="col-sm-4">
                    <div class="support-section">
                        <span class="name">Information</span>
                        <h5>The Toro Company<br>
                            5825 Jasmine St.<br>
                            Riverside, CA 92504</h5>
                    </div>

                    <div class="support-section">
                        <span class="name">TORO®</span><br>
                        <span class="fa-stack fa-lg stacked-icon">
                            <i class="fa fa-circle fa-stack-2x stacked-icon-background"></i>
                            <i class="fa fa-phone fa-stack-1x fa-inverse stacked-icon-foreground"></i>
                        </span>
                        877-345-TORO (8676)
                        <br>
                        <span class="fa-stack fa-lg stacked-icon">
                            <i class="fa fa-circle fa-stack-2x stacked-icon-background"></i>
                            <i class="fa fa-globe fa-stack-1x fa-inverse stacked-icon-foreground"></i>
                        </span>
                        <a href="https://www.toro.com/" target="_blank">Toro.com</a>
                    </div>

                    <div class="support-section">
                        <span class="name">IRRITROL®</span><br>
                        <span class="fa-stack fa-lg stacked-icon">
                            <i class="fa fa-circle fa-stack-2x stacked-icon-background"></i>
                            <i class="fa fa-phone fa-stack-1x fa-inverse stacked-icon-foreground"></i>
                        </span>
                        800-634-TURF (8873)
                        <br>
                        <span class="fa-stack fa-lg stacked-icon">
                            <i class="fa fa-circle fa-stack-2x stacked-icon-background"></i>
                            <i class="fa fa-globe fa-stack-1x fa-inverse stacked-icon-foreground"></i>
                        </span>
                        <a href="https://www.irritrol.com/" target="_blank">Irritrol.com</a>
                    </div>

                    <div class="support-section">
                        <span class="name">UNIQUE LIGHTING SYSTEMS®</span><br>
                        <span class="fa-stack fa-lg stacked-icon">
                            <i class="fa fa-circle fa-stack-2x stacked-icon-background"></i>
                            <i class="fa fa-phone fa-stack-1x fa-inverse stacked-icon-foreground"></i>
                        </span>
                        800-955-4831
                        <br>
                        <span class="fa-stack fa-lg stacked-icon">
                            <i class="fa fa-circle fa-stack-2x stacked-icon-background"></i>
                            <i class="fa fa-globe fa-stack-1x fa-inverse stacked-icon-foreground"></i>
                        </span>
                        <a href="http://www.uniquelighting.com/" target="_blank">UniqueLighting.com</a>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>